/**
 * Generated runtime TestId mirror for frontend/src/pages/MyDelegations.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const MyDelegationsTabId = {
  Incoming: "incoming",
  Outgoing: "outgoing",
} as const;
export type MyDelegationsTabId = typeof MyDelegationsTabId[keyof typeof MyDelegationsTabId];

export const MyDelegationsTestIds = {
  colActions: "col-actions",
  colDelegator: "col-delegator",
  colDeputy: "col-deputy",
  colEndAt: "col-end-at",
  colReason: "col-reason",
  colStartAt: "col-start-at",
  colStatus: "col-status",
  colWorkflowStep: "col-workflow-step",
  createDelegationBtn: "create-delegation-btn",
  incomingDelegationsSection: "incoming-delegations-section",
  myDelegationsPage: "my-delegations-page",
  outgoingDelegationsSection: "outgoing-delegations-section",
  tab: (subtype: MyDelegationsTabId) => `tab-${subtype}` as const,
  tabPrefix: () => "tab-" as TestIdPrefix,
  revokeDelegation: (d_id: string) => `revoke-delegation-${d_id}`,
  revokeDelegationPrefix: () => "revoke-delegation-" as TestIdPrefix
} as const;
